import React, { Component } from 'react'
import { connect } from 'react-redux'
import './styles.css'

import PageWrapper from '../../components/PageWrapper'
import WhiteBox from '../../components/WhiteBox'
import ReactTooltip from 'react-tooltip'
import Sidebar from 'react-sidebar'
import DocDrawer from './drawer'

class Documentation extends Component {
    state = {
        phase: 0,
        userAttributes: null,
        errorMessage: null,
        username: null,
        cognitoUser: null,
        disabled: true,
        changePasswordDisabled: true
    }

    render() {
        const sidebar = <DocDrawer />

        const sidebarProps = {
            sidebar: sidebar,
            docked: true,
            open: true,
            onSetOpen: null
        }

        let marginTopParagraph = '40px'

        return (
            <Sidebar {...sidebarProps}>
                <div className="">
                    <div className="doc-page" style={{ 'margin-bottom': '100px', 'text-align': 'left', padding: '20px', background: '#f1f2f7' }}>
                        <WhiteBox>
                            <h2 style={{ 'border-bottom': '1px solid lightgray', 'margin-bottom': '20px' }} className="">
                                Imports: Upload a segment file
                            </h2>

                            <h3 className="">Requirements</h3>
                            <p>
                                <ul>
                                    <li>
                                        <b>CSV or a .gz file containing csv files with the correct file format</b> without header, separated by '\n'.
                                    </li>
                                    <li>
                                        Maximun <b>1 GB</b> for plain csv files and 500MB for compressed files.
                                    </li>
                                </ul>
                            </p>

                            <div className="alert alert-warning">
                                Uploads are free until 1TB per month of uncompressed data. To increase this limit please contact the{' '}
                                <a href="mailto:admin@audiencerate.com">support</a>.
                            </div>

                            <h3 style={{ marginTop: marginTopParagraph }} className="">
                                Upload a file to the Audiencerate platform
                            </h3>
                            <p>
                                It's possible to upload segment files in two ways:
                                <ul>
                                    <li>
                                        <b>Single Import</b> associate an audience with a list of segments
                                    </li>
                                    <li>
                                        <b>Bulk Import</b> associate multiple audiences with a list of segments uploading a single file
                                    </li>
                                </ul>
                            </p>
                            <h3 style={{ marginTop: marginTopParagraph }} className="">
                                Types of segments ids
                            </h3>
                            <p>
                                <ul>
                                    <li>
                                        <b>Cookie based</b>: we use a matchtable to sync cookies.
                                    </li>
                                    <li>
                                        <b>Mobile (such as AAID for Android and IDFA for iOS devices)</b>: we pass-through the matchtable and upload them
                                        directly.
                                    </li>
                                </ul>
                            </p>
                        </WhiteBox>

                        <WhiteBox>
                            <h2 style={{ 'border-bottom': '1px solid lightgray', 'margin-bottom': '20px' }} className="">
                                Using the Dashboard
                            </h2>

                            <p>
                                Uploading using the Audiencerate Dashboard is the most easiest way to upload your segments. It's only required to have your
                                personal dashboard credentials to make some uploads!
                                <ul>
                                    <li>
                                        To use the <b>Single Import</b> functionality go to <u>Audiences</u> section and make an upload creating / editing an
                                        existing audience.
                                    </li>
                                    <li>
                                        To use the <b>Bulk Import</b> functionality go to <u>Audiences Uploads</u> section and click the "Bulk Import" button.
                                    </li>
                                </ul>
                            </p>
                        </WhiteBox>

                        <WhiteBox>
                            <h2 style={{ 'border-bottom': '1px solid lightgray', 'margin-bottom': '20px' }} className="">
                                Using the API
                            </h2>

                            <h3 style={{ marginTop: marginTopParagraph }} className="">
                                Import flow
                            </h3>
                            <p>
                                <ol>
                                    <li>
                                        First upload a file in the Audiencerate <b>S3 bucket</b>. To make an upload you will need to enable your aws user
                                        attaching the generated policy from the <a href="/servertoserver">S2S Integration</a> under the "Upload S3 Settings"
                                        tab.
                                    </li>
                                    <li>
                                        Tell Audiencerate that the upload is completed by calling the <b>Upload Notification API</b>. This API will return an{' '}
                                        <u>unique Transaction ID</u> for each file uploaded.
                                    </li>
                                    <li>
                                        Check the Import status calling the <b>Import Status API</b>. You can use the Transaction ID to search for a specific
                                        import progress using the "filter" parameter.
                                    </li>
                                </ol>
                                Please see the "AWS CLI UPLOAD CODE SNIPPET" example to see this flow in action: in the{' '}
                                <a href="/servertoserver">S2S Integration</a> section of the dashboard under the "Code Snippet" tab.
                            </p>

                            <h3 style={{ marginTop: marginTopParagraph }} className="">
                                Prerequisities to interfacing with S3
                            </h3>
                            <p>
                                Audiencerate use an AWS S3 Bucket to handle file uploads.
                                <ol>
                                    <li>
                                        First create an <b>IAM user</b> on your AWS account. You will need access key and secret key of this user to make
                                        uploads using the API.
                                    </li>
                                    <li>
                                        Input the User ARN into the Audiencerate Dashboard textbox under <u>S2S Integration</u> section and click the SAVE
                                        button.
                                    </li>
                                    <li>
                                        The Audiencerate platform generates an <b>AWS policy</b> that must be attached to the AWS user created in the first
                                        step. This step is needed to enable the user you have created in step 1 to access Audiencerate S3 bucket and upload
                                        files. You need to attach this <b>IAM Policy</b> to the user you created.
                                    </li>
                                </ol>
                            </p>
                            <div className="alert alert-warning">
                                It's mandatory to generate an external IAM User and to get the Bucket Policy before uploading directly on the Audiencerate S3
                                from API calls.
                            </div>

                            <h3 style={{ marginTop: marginTopParagraph }} className="">
                                Technical Details using the SDK / API
                            </h3>
                            <p>
                                To better understand how to make an upload using the API or Audiencerate Java SDK, please see the <b>Upload Example</b> in the{' '}
                                <a href="https://app.audiencerate.com/servertoserver">S2S Section</a> of the Dashboard (Code Snippets).
                                <br />
                                <br />
                                To start a session you will need:
                                <ol>
                                    <li>
                                        Your <b>IAM access key and secret key</b> for the aws user that you created before.
                                    </li>
                                    <li>
                                        Your <b>User Role ARN</b> generated in the dashboard S2S section (Upload S3 Settings).
                                    </li>
                                    <li>
                                        Your <b>S3 Bucket address</b> generated in the dashboard S2S section (Upload S3 Settings).
                                    </li>
                                    <li>
                                        Your <b>Dashboard credentials</b> (Email / Password) used to access the Audiencerate Dashboard website. Those parameters
                                        are used to login in <u>AWS Cognito</u> service to generate a Temporary token so you can make authenticated api calls to
                                        the Audiencerate REST APIs.
                                    </li>
                                </ol>
                            </p>
                        </WhiteBox>
                        <WhiteBox>
                            <h2 style={{ 'border-bottom': '1px solid lightgray', 'margin-bottom': '20px' }} className="">
                                Import Methods
                            </h2>

                            <h3 style={{ marginTop: marginTopParagraph }} className="">
                                Single Import: Basic Segment Upload
                            </h3>
                            <p>
                                Upload one or more files to connect one list/segment to one destination platform at a time.
                                <br />
                                The file format will be a csv file or a .gz file containing csv files without header, separated by '\n'.
                                <br />
                                <br />
                                For Example:
                                <pre style={{ 'background-color': 'transparent', color: 'black' }}>
                                    <div className="alert alert-secondary" role="alert">
                                        <code style={{ 'background-color': 'transparent', color: 'black' }}>
                                            12333454334553
                                            <br />
                                            123123213123234
                                            <br />
                                            43356434555435
                                            <br />
                                            ...
                                        </code>
                                    </div>
                                </pre>
                                <b>API:</b> Using the <b>Single Import</b> needs to follow a specific procedure:
                                <ol>
                                    <li>Upload one or more files to the Audiencerate S3 Bucket</li>
                                    <li>
                                        Notify Audiencerate by calling the{' '}
                                        <a href="https://apidocs.audiencerate.com/#/default/post_upload_notification">Audience Basic upload notification API</a>
                                        .
                                    </li>
                                </ol>
                            </p>
                            <div className="alert alert-warning">
                                After uploading to the Audiencerate S3 Bucket, it's mandatory to call the{' '}
                                <a href="https://apidocs.audiencerate.com/#/default/post_upload_notification">Audience Basic upload notification API</a> to
                                notify Audiencerate to process the files.
                            </div>
                            <hr />
                            <h3 style={{ marginTop: marginTopParagraph }} className="">
                                Bulk Import: Bulk Segment Upload
                            </h3>
                            <p>
                                Upload one or more files to distribute multiple segments to multiple audience ids lists.
                                <br />
                                The file format will be a csv file or a .gz file containing csv files without header, separated by '\n'.
                                <br />
                                <br />
                                <div className="alert alert-info">
                                    To fetch the list of audiences call the paginated{' '}
                                    <a href="https://apidocs.audiencerate.com/#/default/get_audience">List Audiences API</a>.
                                </div>
                                For Example:
                                <pre style={{ 'background-color': 'transparent', color: 'black' }}>
                                    <div className="alert alert-secondary" role="alert">
                                        <code style={{ 'background-color': 'transparent', color: 'black' }}>
                                            d733fd48-2102-4f05-8bff-0decf2bb85xx,AUD404822300,AUD404822301
                                            <br />
                                            f773c20d-5f64-432b-9f5f-d7ee72eefa3f,AUD404822300,AUD404822301
                                            <br />
                                            USER_IDX, LIST_ID1, LIST_ID2, ...
                                        </code>
                                    </div>
                                </pre>
                                <b>API:</b> Using the <b>Bulk Import</b> needs to follow a specific procedure:
                                <ol>
                                    <li>Upload one or more files to the Audiencerate S3 Bucket</li>
                                    <li>
                                        Notify Audiencerate by calling the{' '}
                                        <a href="https://apidocs.audiencerate.com/#/default/post_audience_bulk_upload">Audience Bulk upload notification API</a>
                                        .
                                    </li>
                                </ol>
                            </p>
                            <div className="alert alert-warning">
                                After uploading to the Audiencerate S3 Bucket, it's mandatory to call the{' '}
                                <a href="https://apidocs.audiencerate.com/#/default/post_audience_bulk_upload">Audience Bulk upload notification API</a> to
                                notify Audiencerate to process the files.
                            </div>
                        </WhiteBox>

                        <WhiteBox>
                            <h2 style={{ 'border-bottom': '1px solid lightgray', 'margin-bottom': '20px' }} className="">
                                Tracking the Import Status
                            </h2>

                            <p>
                                You can track import status in the Audiencerate Dashboard in the section <u>"Imports"</u> or calling the{' '}
                                <a href="https://apidocs.audiencerate.com/#/default/get_event_import">Imports Status API</a>.
                                <br />
                                If the audience is licensed you will also see events of the synchronization process to the various DMPs in the "Syncs" section
                                or calling the <a href="https://apidocs.audiencerate.com/#/default/get_event_sync">Syncs Status API</a>.
                            </p>
                            <p>
                                To search for a particular import you can filter using the Import's Transaction ID in the dashboard or by calling the{' '}
                                <a href="https://apidocs.audiencerate.com/#/default/get_event_import">Imports Status API</a> like this:
                                'https://api.audiencerate.com/event/import?filter=TXID'
                            </p>
                        </WhiteBox>
                    </div>
                </div>
            </Sidebar>
        )
    }
}

export default connect(
    state => ({}),
    {}
)(Documentation)
